@if (hasActivity) {
<section class="portfolio-container">
    @if (hasOffers) {
    <div class="column">
        <h3>{{ 'Offers' | localize }} <span class="group-label">{{ offersHeaderLocalizationKey | localize }}</span></h3>
        @for (offer of activeOffers; track offer.id) {
            <ng-container [ngTemplateOutlet]="offerCard" [ngTemplateOutletContext]="{ $implicit: offer }"></ng-container>
        }
        @if (showOffersSeparator) {
            <div class="group-separator"></div>
            <span class="group-label">{{ ClientActivityLocalizationKeys.ArchivedDeals | localize }}</span>
        }
        @for (offer of archivedOffers; track offer.id) {
            <ng-container [ngTemplateOutlet]="offerCard" [ngTemplateOutletContext]="{ $implicit: offer }"></ng-container>
        }
    </div>
    }

    @if (hasSearches) {
    <div class="column">
        <h3>{{ 'Searches' | localize }} <span class="group-label">{{ searchesHeaderLocalizationKey | localize }}</span></h3>
        @for (search of activeSearches; track search.id) {
            <ng-container [ngTemplateOutlet]="searchCard" [ngTemplateOutletContext]="{ $implicit: search }"></ng-container>
        }
        @if (showSearchesSeparator) {
            <div class="group-separator"></div>
            <span class="group-label">{{ ClientActivityLocalizationKeys.ArchivedDeals | localize }}</span>
        }
        @for (search of archivedSearches; track search.id) {
            <ng-container [ngTemplateOutlet]="searchCard" [ngTemplateOutletContext]="{ $implicit: search }"></ng-container>
        }
    </div>
    }

    @if (hasProjects) {
    <div class="column">
        <h3>{{ 'Projects' | localize }} <span class="group-label">{{ ClientActivityLocalizationKeys.Active | localize }}</span></h3>
        @for (project of projects; track project.id) {
            <app-project-summary-card
                [projectId]="project?.id"
                [name]="project?.name"
                [projectStatusName]="project?.projectStatusName"
                [priceFrom]="project?.priceFrom"
                [priceTo]="project?.priceTo"
                [areaFrom]="project?.areaFrom"
                [areaTo]="project?.areaTo"
                [address]="project?.address"
                [employeeName]="project?.employeeName"
                [primaryImage]="project?.primaryImage"
                [tenantId]="tenantId"
                [disableOnClick]="disableOnClick" />
        }
    </div>
    }
</section>
}

<ng-template #offerCard let-offer>
    <app-offer-card
        [offerId]="offer?.id"
        [price]="offer?.price"
        [oldPrice]="offer?.oldPrice"
        [coverImageSource]="offer?.coverImageSource"
        [offerExternalSystemId]="offer?.offerExternalSystemId"
        [depositsSummary]="offer?.depositsSummary"
        [hasKey]="offer?.hasKey"
        [hasEncumbrances]="offer?.hasEncumbrances"
        [projectId]="offer?.projectId"
        [operationTypeName]="offer?.operationTypeName"
        [estateTypeName]="offer?.estate?.typeName"
        [estateCategoryName]="offer?.estate?.categoryName"
        [estateArea]="offer?.estate?.area"
        [estateAddress]="offer?.estate?.address"
        [offerStatusName]="offer?.offerStatusName"
        [contractTypeName]="offer?.contractTypeName"
        [archiveType]="offer?.archiveType"
        [advantageStatusName]="offer?.advantageStatus?.advantageStatusName"
        [advantageEndDate]="offer?.advantageEndDate"
        [immunityStatusName]="offer?.immunityStatus?.immunityStatusName"
        [immunityEndDate]="offer?.immunityStatus?.immunityEndDate"
        [directionDescription]="offer?.directionDescription"
        [employeeName]="offer?.employeeName"
        [tenantId]="tenantId"
        [openOnClick]="!disableOnClick" />
</ng-template>

<ng-template #searchCard let-search>
    <app-search-card
        [type]="search.operationTypeName"
        [categoryName]="search.estateCategoryName"
        [priceFrom]="search.moneyFrom"
        [priceTo]="search.moneyTo"
        [areaFrom]="search.areaFrom"
        [areaTo]="search.areaTo"
        [populatedPlace]="search.populatedPlaceName"
        [districts]="search.districts"
        [searchId]="search.id"
        [searchMappingAdminId]="search.searchExternalSystemId"
        [statusClass]="search | searchStatusClass"
        [advantageStatusName]="search?.advantageStatus?.advantageStatusName"
        [advantageEndDate]="search?.advantageEndDate"
        [immunityStatusName]="search?.immunityStatus?.immunityStatusName"
        [immunityEndDate]="search?.immunityStatus?.immunityEndDate"
        [employeeName]="search?.employeeName"
        [tenantId]="tenantId"
        [disableOnClick]="disableOnClick"
        [showSurveyActions]="showSurveyActions"
        [surveyTypeName]="search.surveyTypeName"
        (surveyActionClicked)="surveyActionClicked.emit($event)" />
</ng-template>
